import { Dialog, DialogContent, DialogTitle, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { UploadResponseFeedback } from "./types"
import { useTranslation } from "react-i18next"

interface FileUploadResultsDialogProps {
  uploadResponseFeedback: UploadResponseFeedback | null
  onClose: () => void
}

export const FileUploadResultsDialog = (props: FileUploadResultsDialogProps) => {
  const { t } = useTranslation();
  const successCount = props.uploadResponseFeedback?.successCount ?? 0;
  const alreadyExistsCount = props.uploadResponseFeedback?.alreadyExistsCount ?? 0;
  const errors = props.uploadResponseFeedback?.failedRelationships ?? [];

  const title = t(errors.length === 0 ? 'customLinking.results.successTitle' : 'customLinking.results.errorTitle');

  return (
    <Dialog open={!!props.uploadResponseFeedback} onClose={props.onClose} fullWidth={true} maxWidth="md">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="body1" component="p">
            {t('customLinking.results.created', { count: successCount })}
            {alreadyExistsCount > 0 && (
              <span> {t('customLinking.results.existed', { count: alreadyExistsCount })}</span>
            )}
          </Typography>
          {errors.length > 0 && (
            <>
              <Typography variant="body1" component="p">
                {t('customLinking.results.failed', { count: errors.length })}
              </Typography>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>{t('customLinking.sourceValue')}</TableCell>
                      <TableCell>{t('customLinking.relationshipValue')}</TableCell>
                      <TableCell>{t('errors.title')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {errors.map((error) => (
                      <TableRow
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row">
                          {error.sourceValue}
                        </TableCell>
                        <TableCell>{error.relationshipValue}</TableCell>
                        <TableCell>{error.errorCode}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  )
}
